import type { FaireProductEntity } from "../../entity_types/product";

export const p_wme2satdgr: FaireProductEntity = {
  token: "p_wme2satdgr",
  type: "product",
  name: "Scalloped Heart Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/5745b4a9757d80c164b44b4314ce88acceb2b7e6842ca8c6113f9c32994e8169.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1fae3467d1d6a5272f31640e76a450b1b704ab49fb7c36f24975ef884a2a69ae.jpeg",
    "https://cdn.faire.com/fastly/c4457f601fbd1d29580a531d7c22aebce52c4de200c3d6295f66361ba309ea45.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:28.209Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
